module.exports = __webpack_public_path__ + "static/media/bg black copy 4.34cfeb84.svg";